// Vendors
import { VARIANTS } from '@openbank/ziniaweb-ui-components';
import { FeatureFlagsLendingOnboardingEnumeration } from '@gruposantander/opbpay-ui-core-models';

const BACKGROUND_MODAL_FEATURE_FLAG_PROPS = {
    id: FeatureFlagsLendingOnboardingEnumeration.BACKGROUND_PROVIDER,
  },
  BACKGROUND_MODAL_COMPONENT_PROPS = {
    blocked: true,
    contentScrollArias: {
      'aria-label': 'Modal content scrollable',
    },
    open: true,
    maxWidth: '620px',
    variant: VARIANTS.ModalVariantType.DEFAULT,
  };

export { BACKGROUND_MODAL_FEATURE_FLAG_PROPS, BACKGROUND_MODAL_COMPONENT_PROPS };
